import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';

@Component({
  selector: 'brn-email-connection-modal',
  templateUrl: './email-connection-modal.component.html',
  styleUrls: ['./email-connection-modal.component.scss'],
})
export class EmailConnectionModalComponent implements OnInit {
  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  newConnection = true;

  emailForm = this.formBuilder.group({
    email: ['', Validators.required],
    username: ['', Validators.required],
    password: ['', Validators.required],
    host: ['', Validators.required],
    port: ['', Validators.required],
    tls: [true, Validators.required],
    smtp_host: ['', Validators.required],
    smtp_port: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<EmailConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      const providerData = data.providerData;
      this.newConnection = false;
      this.emailForm.patchValue(providerData);
    }
  }

  ngOnInit(): void {}

  get validForm(): boolean {
    return this.emailForm.valid;
  }

  createConnection(): void {
    console.log(this.emailForm.value);

    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.emailForm.value;
    this.store.dispatch(new CreateBotConnection('email', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.emailForm.value;
    this.store.dispatch(new UpdateBotConnection('email', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('email'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
